// extracted by mini-css-extract-plugin
export default {"text":"TextInput_text__iAgB2"};